import { useCallback, useState } from 'react';

import {
  AttributeGroupEntry,
  SkyMapAttribute,
} from '../../../../../../../viewer/elements/design/skymap-extras';
import { SubscriptionTopic } from '../../../../../../../viewer/messaging/pubsub';
import { DesignTool } from '../../../../../../../viewer/tools/design-tool';
import { useSubscribe } from '../../../../../../hooks/use-subscribe';

export function useAttributes(tool: DesignTool) {
  const [attributes, setAttributes] = useState<SkyMapAttribute[]>(
    tool.asset.designNode.getAttributes(),
  );
  const [attributeGroups, setAttributeGroups] = useState<
    { name: string; entries: AttributeGroupEntry[] }[]
  >(tool.asset.designNode.getAttributeGroups());

  const refresh = useCallback(() => {
    setAttributes(tool.asset.designNode.getAttributes());
    setAttributeGroups(tool.asset.designNode.getAttributeGroups());
  }, [tool]);

  useSubscribe(SubscriptionTopic.DesignAttributesChanged, () => {
    refresh();
  });

  return { attributes, attributeGroups };
}
